import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "user-detail",
  components: {
    AppHeader
  },
  created() {
    this.getUser();
  },
  data() {
    return {
      user: "",
      getUserEnd: false
    };
  },
  computed: {
    joinDayFormat() {
      return dayjs(this.user.join_day).format("YYYY年MM月DD日");
    },
    birthdayFormat() {
      return dayjs(this.user.birth_day).format("YYYY年MM月DD日");
    }
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
      this.getUserEnd = true;
    },
    goUserEdit() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}/edit` });
    },
    goDepartmentHistory() {
      this.$router.push({
        path: `/department_history/${this.$route.params.user_id}`
      });
    },
    goPositionHistory() {
      this.$router.push({
        path: `/position_history/${this.$route.params.user_id}`
      });
    },
    goRankHistory() {
      this.$router.push({
        path: `/rank_history/${this.$route.params.user_id}`
      });
    },
    content(word) {
      return word
        ? word
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;")
            .replace(/\r?\n/g, "<br>")
        : "";
    },
    authorityCheck(menu) {
      if (localStorage.user_authority == 2) {
        // 役員でログイン
        if (
          menu == "edit" ||
          menu == "loginId" ||
          menu == "authority" ||
          menu == "hourlyPay"
        ) {
          // 編集・削除ボタン、ログインID、システム権限非表示
          return false;
        }
      } else if (localStorage.user_authority == 3) {
        // 承認者でログイン
        if (
          menu == "edit" ||
          menu == "loginId" ||
          menu == "departmentHistory" ||
          menu == "positionHistory" ||
          menu == "authority" ||
          menu == "hourlyPay" ||
          menu == "rankHistory" ||
          menu == "content"
        ) {
          // 編集・削除ボタン、ログインID、部署履歴リンク、役職履歴リンク、システム権限、時給、各種履歴リンク、備考非表示
          return false;
        }
      } else if (localStorage.user_authority == 4) {
        // 総務部でログイン
        if (menu == "authority" || menu == "rankHistory" || menu == "content") {
          // システム権限、各種履歴リンク、備考非表示
          return false;
        }
      }
      return true;
    }
  }
};
